module.exports = __webpack_public_path__ + "static/media/DB-1538_58x58x58_allWidthsMax.61f5e770.tom";